// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Ahd6","empty":"ModalGraph_empty__2ROaD"};